import {getDataInLocalStorage, removeDataInLocalStorage, saveDataToLocalStorage} from "@/utils/localStorage";

const state = {
    user:{},//登录的所有信息
    token:'',//token
    role:'',//角色
    reminderShown:'',//是否打开过日期提醒
    roleList:[],
    headerReminderCalled: false,
    reminderHeaderCalled:false,
    changeRed:false
}
export const roleEnCh = {
    'ADMIN': '超级管理员',
    'MANAGER': '管理员',
    'SALES': '销售',
    'SALES_MANAGER': '销售经理',
    'FINANCE': '财务经理',
    'CASHIER':'出纳',
    'BUSINESS_COMMERCIAL':'商务专员',
    'LAB':'实验室账号',
    'SALES_ASSI':'销售助理',
    'SALES_ASSI_MANAGER':'销售助理主管',
    'TECH':'技术支持',
    'ANALYSE':'分析',
    'APPROVAL_SPECIALIST':'合同审批专员',
    'AUDITOR':'审核'
}
export const roleManager = {
    'MANAGER': '商务经理',
    'SALES': '销售',
    'ADMIN': '超级管理员',
    'SALES_MANAGER': '销售经理',
    'FINANCE': '财务经理',
    'CASHIER':'出纳',
    'BUSINESS_COMMERCIAL':'商务专员',
    'LAB':'实验室账号',
    'SALES_ASSI':'销售助理',
    'SALES_ASSI_MANAGER':'销售助理主管',
    'TECH':'技术支持',
    'ANALYSE':'分析',
    'APPROVAL_SPECIALIST': '合同审批专员',
    'AUDITOR': '审核'
}
const getters = {
    getToken: (state) => {
        if (!state.token) {
            state.token = getDataInLocalStorage('token')
        }
        return state.token
    }  ,
    getUser: (state) => {
        if (!state.user||!state.user.size) {
            state.user =JSON.parse(getDataInLocalStorage('user'))
        }
        return state.user
    } ,
    getRole: (state) => {
        if (!state.role) {
            state.role =getDataInLocalStorage('role')
        }
        return state.role
    } ,
    getRoleList: (state) => {
        if (!(state.roleList&&state.roleList.length>0)) {
            state.roleList = getDataInLocalStorage('roleList')?JSON.parse(getDataInLocalStorage('roleList')):[]
        }
        return state.roleList
    },
    getHeaderReminderCalled: (state) => {
        return state.headerReminderCalled
    },
    getReminderHeaderCalled: (state) => {
        return state.reminderHeaderCalled
    },
    getChangeRed: (state) => {
        return state.changeRed
    }
}
const mutations = {
    setToken: (state, token) => {
        saveDataToLocalStorage('token', token)
        state.token = token
    },
    setUser: (state, user) => {
        saveDataToLocalStorage('user', user)
        state.user = user
    },
    setReminder: (state, reminderShown) => {
        saveDataToLocalStorage('reminderShown', reminderShown)
        state.reminderShown = reminderShown
    },
    setRole:(state, role) => {
        saveDataToLocalStorage('role', role)
        state.role = role
    },
    setHeaderReminderCalled:(state, headerReminderCalled) => {
        saveDataToLocalStorage('headerReminderCalled',headerReminderCalled)
        state.headerReminderCalled = headerReminderCalled
    },
    setReminderHeaderCalled:(state, reminderHeaderCalled) => {
        saveDataToLocalStorage('reminderHeaderCalled',reminderHeaderCalled)
        state.reminderHeaderCalled = reminderHeaderCalled
    },
    setChangeRed:(state,changeRed) => {
        saveDataToLocalStorage('changeRed',changeRed)
        state.changeRed = changeRed
    },
    setInit(state){
        removeDataInLocalStorage('user')
        removeDataInLocalStorage('token')
        removeDataInLocalStorage('reminderShown')
    },
    setRoleLit: (state, roleList) => {
        saveDataToLocalStorage('roleList', JSON.stringify(roleList))
        state.roleList = roleList
    },
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
}
